import React, { useState, useEffect } from 'react';
import { footerData } from '../data/mock.js';
import whatsappImg from '../asset/images/whatsapp.png';

const STYLES = `
  .lux-whatsapp-float {
    position: fixed;
    bottom: 32px;
    right: 32px;
    z-index: 50;
  }
  .lux-whatsapp-float-btn {
    width: 60px;
    height: 60px;
    background: #25D366;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0 8px 32px rgba(37, 211, 102, 0.4);
    transition: transform 0.2s, box-shadow 0.2s;
    position: relative;
    padding: 0;
  }
  .lux-whatsapp-float-btn:hover {
    transform: scale(1.08);
    box-shadow: 0 12px 48px rgba(37, 211, 102, 0.55);
  }
  .lux-wa-ring {
    position: absolute;
    inset: 0;
    background: #25D366;
    animation: pingWA 2s cubic-bezier(0,0,0.2,1) infinite;
    border-radius: 50%;
  }
  @keyframes pingWA {
    0%   { transform: scale(1); opacity: 0.6; }
    80%  { transform: scale(2); opacity: 0; }
    100% { transform: scale(2); opacity: 0; }
  }
  .lux-wa-tooltip {
    position: absolute;
    bottom: calc(100% + 16px);
    right: 0;
    background: #ffffff;
    padding: 16px 20px;
    min-width: 220px;
    box-shadow: 0 16px 48px rgba(0,0,0,0.12);
    border: 0.5px solid rgba(0,0,0,0.1);
  }
  .lux-wa-tooltip p {
    font-family: 'Montserrat', sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #000000;
    margin: 0;
    line-height: 1.5;
    padding-right: 16px;
  }
  .lux-wa-tooltip-close {
    position: absolute;
    top: 8px; right: 8px;
    background: none;
    border: none;
    cursor: pointer;
    color: rgba(0,0,0,0.4);
    font-size: 16px;
    line-height: 1;
    padding: 4px;
    transition: color 0.2s;
  }
  .lux-wa-tooltip-close:hover {
    color: #000000;
  }
`;

const WhatsAppButton = () => {
  const [visible, setVisible] = useState(false);
  const [tooltip, setTooltip] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setVisible(true), 1200);
    const t2 = setTimeout(() => setTooltip(true), 3500);
    const t3 = setTimeout(() => setTooltip(false), 9000);
    return () => [t1, t2, t3].forEach(clearTimeout);
  }, []);

  const handleClick = () => {
    window.open(`https://wa.me/${footerData?.whatsappNumber || footerData?.phone}?text=Hi, I'm interested in your services.`, '_blank');
  };

  if (!visible) return null;

  return (
    <>
      <style>{STYLES}</style>
      <div className="lux-whatsapp-float">
        {tooltip && (
          <div className="lux-wa-tooltip">
            <p>Have questions? Chat with us on WhatsApp!</p>
            <button className="lux-wa-tooltip-close" onClick={() => setTooltip(false)}>×</button>
          </div>
        )}
        <button onClick={handleClick} aria-label="Chat on WhatsApp" className="lux-whatsapp-float-btn">
          <div className="lux-wa-ring" />
          <img
            src={whatsappImg}
            alt="WhatsApp"
            style={{
              width: "34px",
              height: "34px",
              objectFit: "contain",
              filter: "brightness(0) invert(1)",
              position: "relative",
              zIndex: 1
            }}
          />
        </button>
      </div>
    </>
  );
};

export default WhatsAppButton;
